export enum FeaturedContentStyle {
  LIST = 'List',
  FADING = 'Fading',
  SCROLLING = 'Scrolling',
  SCROLL_FADE = 'ScrollFade',
}
